import { render } from "./IbanForm.vue?vue&type=template&id=4d027fce"
import script from "./IbanForm.vue?vue&type=script&lang=js"
export * from "./IbanForm.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./IbanForm.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_73d03741%2Fpackages%2Fcustomer%2Fsrc%2Fcomponents%2FIbanForm.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__